// extracted by mini-css-extract-plugin
module.exports = {"priceLevelDisplay":"PriceLevelDisplay_priceLevelDisplay__9SqkW","priceLevelDisplayDefault":"PriceLevelDisplay_priceLevelDisplayDefault__HoJ3j"};